<div
  class="mbs-form"
  [formGroup]="companySearchForm">
  <div class="row py-1 mb-3">
    <div class="col">
      <mbs-input
        formControlName="name"
        [appendButtons]="[
          {
            type: 'secondary',
            icon: 'ico ico-Search'
          }
        ]"
        [buttonClickOnEnter]="true"
        [clearButton]="true"
        [disabledSelf]="loading"
        [placeholder]="'shared:placeholders.search' | i18next"
        (buttonClick)="search()"
        (clear)="clear()">
      </mbs-input>
    </div>

    @if (showAddNewCompany && (permissionsEnum.ManageCompanies | can: 'read') && (permissionsEnum.AccessToAllCompanies | can: 'read')) {
      <div class="col-auto">
        <mbs-button
          class="w-100"
          icon="ico ico-Plus"
          (click)="addNewCompany()">
          {{ 'shared:computers.addNewCompany' | i18next }}
        </mbs-button>
      </div>
    }
  </div>
</div>

<mbs-table-grid
  [bindDisabledValues]="disabledRowCondition"
  [cancelSelectionText]="'shared:paging.cancelSelection' | i18next"
  [data]="data"
  [headers]="headers"
  [infiniteScroll]="true"
  [infiniteScrollDistance]="infiniteScrollDistance"
  [infiniteScrollLoading]="infiniteScrollLoading"
  [infiniteScrollThrottle]="infiniteScrollThrottle"
  [keepState]="true"
  [loading]="loading"
  [maxHeight]="'50vh'"
  [multipleSelect]="multipleSelect"
  [myTrackBy]="trackBy"
  [noDataMessage]="noDataText"
  [selectable]="true"
  [selectAllButtonText]="selectAllText()"
  [selectAllIgnoreDisabled]="true"
  [selectedCountText]="selectedText()"
  [selectedItems]="selected"
  [serverSidePagination]="false"
  [showSelectAllCheckbox]="true"
  [showSelectAllHint]="true"
  [showTableCheckboxes]="true"
  [tooltipForDisabledRow]="tooltipForDisabledRow"
  [totalItems]="total"
  [totalSelectedItems]="selected.length"
  (changeSelected)="onSelectedRowsChanged($event)"
  (scrolled)="onScrolled$.next(true)"
  (selectAllOnAllPages)="selectAllOnAllPages($event)">
  <ng-template
    let-item
    mbsTableCell>
    {{ item.name }}
  </ng-template>
</mbs-table-grid>
